'use client';

import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';
import type { InternalEvidenceContentDto } from '@terra/shared-contracts-internal-network';

type InternalEvidenceContextValue = {
  surfaceId: string;
  fetchEvidence: (evidenceId: string) => Promise<InternalEvidenceContentDto>;
};

const InternalEvidenceContext = createContext<
  InternalEvidenceContextValue | undefined
>(undefined);

export function InternalEvidenceProvider({
  children,
  surfaceId,
  fetchEvidence,
}: {
  children: ReactNode;
  surfaceId: string;
  fetchEvidence: (evidenceId: string) => Promise<InternalEvidenceContentDto>;
}) {
  const value = useMemo(
    () => ({ surfaceId, fetchEvidence }),
    [fetchEvidence, surfaceId],
  );

  return (
    <InternalEvidenceContext.Provider value={value}>
      {children}
    </InternalEvidenceContext.Provider>
  );
}

export function useInternalEvidenceOptional():
  | InternalEvidenceContextValue
  | undefined {
  return useContext(InternalEvidenceContext);
}
